<template>
    <div>
        <div class="crumb-nav">
            <a-breadcrumb>
                <a-breadcrumb-item>
                    <home-outlined />
                </a-breadcrumb-item>
                <a-breadcrumb-item>
                    视频
                </a-breadcrumb-item>
                <a-breadcrumb-item>戏曲类</a-breadcrumb-item>
            </a-breadcrumb>
        </div>
        <div class="nav-line"></div>

        <a-form ref="formRef" class="form-box" :model="formState" v-bind="formItemLayout" @finishFailed="onFinishFailed"
            @finish="onFinish">
            <a-form-item label="部门ID" name="dept_id" style="display: none;">
                <a-input class="half-input" disabled v-model:value="formState.dept_id" />
            </a-form-item>
            <a-form-item label="项目名称" name="title" :rules="[{ required: true, message: '请输入项目名称!' }]">
                <a-input class="half-input" v-model:value="formState.title" placeholder="请输入项目名称" />
            </a-form-item>
            <a-form-item label="项目序号" name="code" style="display: none;">
                <a-input class="half-input" v-model:value="formState.code" placeholder="请输入项目序号" />
            </a-form-item>
            <a-form-item label="年代" name="category">
                <a-tree-select class="half-input" placeholder="请选择年代" :tree-data="year_list"
                    v-model:value="formState.year">
                </a-tree-select>
            </a-form-item>
            <a-form-item label="作者" name="author">
                <a-input v-model:value="formState.author" class="half-input" />
            </a-form-item>
            <a-form-item label="资源类型" name="content_type">
                <a-radio-group v-model:value="formState.content_type">
                    <a-radio :value="item.code" v-for="(item, index) in contentModel" :key="index">
                        {{ item.name }}</a-radio>
                </a-radio-group>
            </a-form-item>
            <a-form-item label="资源" name="extraList">
                <div style="width:400px">
                    <a-upload v-model:fileList="formState.extraList" class="margin-bottom16" name="iFile"
                        :headers="headers" :multiple="true" :showUploadList="true" :action="uploadAction"
                        :customRequest="cusUpload" :progress="progress" @change="uploadHandleChange">
                        <a-button type="dashed" block class="medium-input">
                            <PlusOutlined />
                            添加
                        </a-button>
                    </a-upload>
                </div>
            </a-form-item>
            <a-form-item v-if="formState.content_type == 'article'" label="内容" name="content"
                :rules="[{ required: true, message: '请输入内容!' }]">
                <BasicEditor v-model="formState.content"></BasicEditor>
            </a-form-item>

            <a-form-item :wrapper-col="{ span: 12, offset: 4 }">
                <a-button type="primary" html-type="submit">保存</a-button>
            </a-form-item>
        </a-form>

    </div>
</template>
<script>
    import {
        defineComponent,
        onMounted,
        ref,
        reactive,
        watch
    } from "vue";
    import * as Api from "@/views/resource/api";

    import {
        HomeOutlined,
        PlusOutlined
    } from "@ant-design/icons-vue";

    import {
        useRoute,
        useRouter
    } from "vue-router";

    import storage from "store";

    import {
        message,
        Modal
    } from "ant-design-vue";

    import BasicEditor from "@/components/Editor";

    import OSS from 'ali-oss';

    export default defineComponent({
        name: "CsLinks",
        components: {
            HomeOutlined,
            PlusOutlined,
            BasicEditor
        },
        props: {},
        emits: [],
        setup() {
            const router = useRouter();
            const route = useRoute();

            const query_dept_id = ref(parseInt(route.query.dept_id ? route.query.dept_id : 0));

            watch(
                () => route.query.dept_id,
                (newVal, oldVal) => {
                    if (newVal != oldVal) {
                        query_dept_id.value = newVal;
                    }
                }
            )

            watch(
                () => route.query.dept_id,
                (newVal, oldVal) => {
                    // console.log('监听基本类型数据testStr')
                    // console.log('new', newVal)
                    // console.log('old', oldVal)
                    if (newVal != oldVal) {
                        formState.dept_id = route.query.dept_id;
                    }
                }
            )



            const year_list = ref([]);

            const getYearList = () => {
                // 获取年限
                Api.year_list().then((res) => {
                    if (res.status == 200) {
                        year_list.value = res.data;
                    }
                });
            }

            const contentModel = ref([{
                    name: "视频",
                    code: "video",
                },
                {
                    name: "图片",
                    code: "image",
                },
                {
                    name: "文章",
                    code: "article",
                },
                {
                    name: "音频",
                    code: "audio",
                },
            ]);

            const formRef = ref();

            const formState = reactive({
                category_id: 1,
                dept_id: 0,
                title: "",
                thumb: "",
                description: "",
                content_type: "video",
                content: "",
                fileList: [],
                imageList: [],
                status: "1",
                flag: [],
                year:"",

                // 扩展信息
                source: "",
                source_url: "",
                author: "",
                editor: "",
                push_time: "",
                keywords: "",
                seo_desc: "",
                sort: 100,
                extraFields: [],
                extraList: [],
            });

            const resetForm = () => {
                formRef.value.resetFields();
                formState.dept_id = route.query.dept_id;
            };

            const onFinish = () => {
                formRef.value
                    .validate()
                    .then(() => {
                        Api.articleCreate(formState).then((res) => {
                            if (res.status === 200) {
                                if (res.data == true) {
                                    Modal.confirm({
                                        title: "提示",
                                        content: res.message,
                                        okText: "继续添加",
                                        cancelText: "返回列表",
                                        onOk() {
                                            resetForm();
                                        },
                                        onCancel() {
                                            goToArticleList();
                                        },
                                    });
                                } else {
                                    Modal.success({
                                        title: "提示",
                                        content: res.message,
                                        okText: "返回列表",
                                        onOk() {
                                            goToArticleList();
                                        },
                                    });
                                }
                            } else {
                                message.error(res.message);
                            }
                        });
                    })
                    .catch((error) => {
                        console.log("error", error);
                    });
            };

            const goToArticleList = () => {
                router.push({
                    path: "/resource/list/" + formState.content_type,
                    query: {
                        dept_id: route.query.dept_id
                    },
                });
            }

            const onFinishFailed = (errorInfo) => {
                console.log("Failed:", errorInfo);
            };

            const headers = ref({
                "Access-Token": storage.get("ACCESS_TOKEN"),
            });

            //上传文件
            const uploadAction = Api.upload;

            const upStsData = reactive({
                accessKeyId: '',
                accessKeySecret: '',
                SecurityToken: '',
            });

            const getStsToken = () => {
                Api.getStsToken().then((res) => {
                    if (res.status == 200) {
                        upStsData.accessKeyId = res.data.AccessKeyId;
                        upStsData.accessKeySecret = res.data.accessKeySecret;
                        upStsData.SecurityToken = res.data.SecurityToken;
                    }
                });
            }

            const progress = {
                strokeColor: {
                    '0%': '#108ee9',
                    '100%': '#87d068',
                },
                strokeWidth: 3,
                format: percent => `${parseFloat(percent.toFixed(2))}%`,
                class: 'test',
            };

            const cusUpload = (e) => {
                const client = new OSS({
                    // yourRegion填写Bucket所在地域。以华东1（杭州）为例，Region填写为oss-cn-hangzhou。
                    region: "oss-cn-chengdu",
                    // 从STS服务获取的临时访问密钥（AccessKey ID和AccessKey Secret）。
                    accessKeyId: upStsData.accessKeyId,
                    accessKeySecret: upStsData.accessKeySecret,
                    // 从STS服务获取的安全令牌（SecurityToken）。
                    stsToken: upStsData.SecurityToken,
                    // 填写Bucket名称，例如examplebucket。
                    refreshSTSToken: async () => {
                        // 向您搭建的STS服务获取临时访问凭证。
                        getStsToken;
                        return {
                            accessKeyId: upStsData.accessKeyId,
                            accessKeySecret: upStsData.accessKeySecret,
                            stsToken: upStsData.SecurityToken
                        }
                    },
                    // 刷新临时访问凭证的时间间隔，单位为毫秒。
                    refreshSTSTokenInterval: 300000,
                    bucket: "abzwhg-resource",
                });

                let oss_file_path = formState.year + '/' + formState.dept_id + '/';

                client.multipartUpload(oss_file_path + e.file.name, e.file, {
                    progress: function (percentage) { // 获取进度条的值
                        // console.log(percentage)
                        const percent_num = parseInt(percentage * 100);
                        // console.log(percent_num)
                        e.onProgress({ percent:percent_num });
                    },
                    partSize: 102400
                }).then(res => {
                    // console.log(res);
                    e.onSuccess({res})
                }).catch(err => {
                    console.log('上传失败', err)
                })
            }

            const uploadHandleChange = (info) => {
                // console.log(info)
                if (info.file.status === "done") {
                    if (info.file.status == 'done') {
                        message.success(`${info.file.name} 上传成功`);
                        console.log(formState.fileList);
                    } else {
                        message.error('22222');
                        message.error(info.file.response.message);
                    }
                } else if (info.file.status === "error") {
                    message.error(`${info.file.name} 上传失败.`);
                }
            };

            // 初始化
            onMounted(() => {
                formState.dept_id = route.query.dept_id;
                getYearList();
                getStsToken();
            });

            return {
                cusUpload,
                contentModel,
                formRef,
                formState,
                resetForm,
                onFinish,
                onFinishFailed,
                uploadAction,
                uploadHandleChange,
                headers,
                year_list,
                progress,
                formItemLayout: {
                    labelCol: {
                        span: 4,
                    },
                    wrapperCol: {
                        span: 20,
                    },
                },
            };
        },
    });
</script>
<style lang="less" scoped>
    .crumb-nav {
        display: flex;
        justify-content: space-between;
    }

    .nav-line {
        width: 100%;
        height: 6px;
        background: url('~@/assets/img/s5.png') repeat-x;
        margin: 20px 0;
    }

    .form-box {
        padding-top: 20px;
    }

    .search-box {
        flex-wrap: wrap;

        .year-item {
            cursor: pointer;
            display: inline-block;
            width: 100px;
            margin-right: 10px;
            margin-bottom: 10px;
            height: 42px;
            line-height: 42px;
            text-align: center;
            background: url('~@/assets/img/year.png') no-repeat center;
        }

        .year-item:hover {
            color: #fff;
            background: url('~@/assets/img/year_active.png') no-repeat center;
        }

        .active {
            color: #fff;
            background: url('~@/assets/img/year_active.png') no-repeat center;
        }
    }

    .table-content {
        margin-top: 20px;
    }
</style>